<template>
  <footer class="footer">
    &copy; 2022 <a href="mailto:dgr.wroc@gmail.com">dgrzeg</a>
  </footer>
</template>

<style lang="scss" scoped>
.footer {
  border-top: 4px solid #d3d3d3;
  font-size: 1.5rem;
  padding: 2rem;
  color: #fff;
  background-color: #000;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  a {
    cursor: pointer;
    margin: 0 1rem;

    &:hover {
      transform: translateY(-3px);
    }

    &:active {
      transform: translateY(-1px);
    }
  }
}
</style>
